<!-- Class Progress Table -->
<div class="table-responsive">
  <table class="table table-hover">
    <thead class="table-light">
      <tr class="text-center">
        <th class="fw-bold">
          <i class="fa fa-hashtag text-primary"></i>
          Class
        </th>
        <th class="fw-bold">
          <i class="fa fa-video text-info"></i>
          Video
        </th>
        <th class="fw-bold">
          <i class="fa fa-file-alt text-warning"></i>
          Handout
        </th>
        <th class="fw-bold">
          <i class="fa fa-question-circle text-danger"></i>
          Quiz
        </th>
        <th class="fw-bold">
          <i class="fa fa-calendar text-muted"></i>
          Available
        </th>
        <th class="fw-bold">
          <i class="fa fa-play text-secondary"></i>
          Started
        </th>
        <th class="fw-bold">
          <i class="fa fa-check text-success"></i>
          Completed
        </th>
        <th class="fw-bold" *ngIf="editMode">
          <i class="fa fa-unlock text-danger"></i>
          Override
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of userClasses" class="text-center align-middle">
        
        <!-- Class ID -->
        <td>
          <span class="badge bg-primary fs-6">{{item.classId}}</span>
        </td>
        
        <!-- Video Completion -->
        <td (click)="editMode ? item.isVideoCompleted = !item.isVideoCompleted : ''">
          <div class="cursor-pointer" [class.clickable]="editMode">
            <i *ngIf="item.isVideoCompleted; else notFinishedVideo" 
               class="fa fa-check-circle fa-lg text-success" 
               title="Video Completed"></i>
            <ng-template #notFinishedVideo>
              <i class="fa fa-times-circle fa-lg text-danger" 
                 title="Video Not Completed"></i>
            </ng-template>
          </div>
        </td>
        
        <!-- Handout Completion -->
        <td (click)="editMode ? item.isHandoutCompleted = !item.isHandoutCompleted : ''">
          <div class="cursor-pointer" [class.clickable]="editMode">
            <i *ngIf="item.isHandoutCompleted; else notFinishedHo" 
               class="fa fa-check-circle fa-lg text-success" 
               title="Handout Completed"></i>
            <ng-template #notFinishedHo>
              <i class="fa fa-times-circle fa-lg text-danger" 
                 title="Handout Not Completed"></i>
            </ng-template>
          </div>
        </td>
        
        <!-- Quiz Completion -->
        <td (click)="editMode ? item.isQuizCompleted = !item.isQuizCompleted : ''">
          <div class="cursor-pointer" [class.clickable]="editMode">
            <i *ngIf="item.isQuizCompleted; else notFinishedQz" 
               class="fa fa-check-circle fa-lg text-success" 
               title="Quiz Completed"></i>
            <ng-template #notFinishedQz>
              <i class="fa fa-times-circle fa-lg text-danger" 
                 title="Quiz Not Completed"></i>
            </ng-template>
          </div>
        </td>
        
        <!-- Date Available -->
        <td>
          <small class="text-muted">{{getAvailableDate(item)}}</small>
        </td>
        
        <!-- Date Started -->
        <td>
          <small class="text-muted">{{getStartedDate(item)}}</small>
        </td>
        
        <!-- Date Completed -->
        <td>
          <small class="text-muted">{{getCompletedDate(item)}}</small>
        </td>
        
        <!-- Override Actions (Edit Mode Only) -->
        <td *ngIf="editMode">
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-warning btn-sm" 
                    (click)="item.isAvailable = !item.isAvailable"
                    [title]="item.isAvailable ? 'Make Unavailable' : 'Make Available'">
              <i class="fa fa-unlock" *ngIf="item.isAvailable"></i>
              <i class="fa fa-lock" *ngIf="!item.isAvailable"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>